import Flickity from 'flickity';
import { hasTouch } from '../utils/touch';

// Photo sliders. Desktop: autoplay, paused while hovering the control button
// (its icon switches eye ↔ pause). Touch: no autoplay, the button goes to the next slide.
export default function sliders() {
    document.querySelectorAll('.slider-container').forEach((el) => {
        const touch = hasTouch();
        const flickity = new Flickity(el, {
            cellSelector: '.item',
            wrapAround: true,
            autoPlay: !touch,
            contain: true,
            prevNextButtons: false,
            pageDots: true,
        });

        const controls = [...el.parentElement.children].filter((c) => c !== el && c.classList.contains('slider-controls'));
        controls.forEach((button) => {
            if (touch) {
                button.addEventListener('click', () => flickity.next());
                return;
            }
            const toggleIcon = () => button.querySelectorAll('.fa').forEach((icon) => {
                icon.classList.toggle('fa-eye');
                icon.classList.toggle('fa-pause');
            });
            button.addEventListener('mouseenter', () => {
                toggleIcon();
                flickity.pausePlayer();
            });
            button.addEventListener('mouseleave', () => {
                toggleIcon();
                flickity.unpausePlayer();
            });
        });
    });
}
